"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RankingsList = exports.Rankings = exports.RankingsItem = undefined;

var _selectors = require("../selectors");

var _selectors2 = _interopRequireDefault(_selectors);

var _urls = require("./util/urls");

var Url = _interopRequireWildcard(_urls);

var _reactRedux = require("react-redux");

var _reselect = require("reselect");

var _compose = require("recompose/compose");

var _compose2 = _interopRequireDefault(_compose);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// RankingsItem is just here for the flow-types
var RankingsItem = exports.RankingsItem = (0, _compose2.default)();
var Rankings = exports.Rankings = (0, _compose2.default)(Url.leagueRank, (0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    rankings: _selectors2.default.rankings.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    list: _selectors2.default.rankings.list
  })
})));
var RankingsList = exports.RankingsList = (0, _compose2.default)((0, _reactRedux.connect)((0, _reselect.createStructuredSelector)({
  rankNames: _selectors2.default.chars2.rankings.names
})));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ../core/lib/containers/rankings.js
// module id = 847
// module chunks = 0